const COOKIE_NOTICE_KEY = "medein-cookie-choice";

function getStorage(storage) {
  if (storage) return storage;
  if (typeof window === "undefined") return null;
  return window.localStorage;
}

export function hasAcknowledgedCookieNotice(storage) {
  try {
    const value = getStorage(storage)?.getItem(COOKIE_NOTICE_KEY);
    return value === "acknowledged" || value === "accepted";
  } catch {
    return false;
  }
}

export function acknowledgeCookieNotice(storage) {
  try {
    const target = getStorage(storage);
    if (!target) return false;
    target.setItem(COOKIE_NOTICE_KEY, "acknowledged");
    return true;
  } catch {
    return false;
  }
}
